import { createSelector } from 'reselect';

const selectUser = () => state => state.app.user;
const selectLeadsPageDomain = () => state => state.leads;

const selectFetching = () => createSelector(
  selectLeadsPageDomain(),
  substate => substate.fetching
)

// Whether the leads request has SETTLED — succeeded or failed — as opposed to
// `fetching`, which is only true while one is in flight. See the reducer.
const selectLoaded = () => createSelector(
  selectLeadsPageDomain(),
  substate => substate.loaded
)

// Why the leads FETCH failed, as opposed to the shared `errors`, which a failed
// CSV export writes too. Only this one may decide what the list renders.
const selectListError = () => createSelector(
  selectLeadsPageDomain(),
  substate => substate.listError
)

const selectUpgradeRequired = () => createSelector(
  selectLeadsPageDomain(),
  substate => Boolean(substate.upgradeRequired)
)

const selectFilterForm = () => createSelector(
  selectLeadsPageDomain(),
  substate => {
    const keys = ['dateRange', 'sourceChannel', 'search']
    var data = {};
    if (substate) {
      keys.map(key => {
        data[key] = substate[key];
      })
    }

    return data;
  }
);

const selectAllLeads = () => createSelector(
  selectLeadsPageDomain(),
  substate => substate.allLeads
);

const selectPagingObject = () => createSelector(
  selectLeadsPageDomain(),
  substate => substate.paging
);

export {
    selectUser,
    selectFilterForm,
    selectFetching,
    selectLoaded,
    selectListError,
    selectUpgradeRequired,
    selectAllLeads,
    selectPagingObject,
  };